import LanguageUnitRatioStatuses from '@/common/models/unit/LanguageUnitRatioStatuses';

export interface ICreativeSizeData {
  impressionData: {
    totalImpressions: number;
    impressionsByUnitDimensions;
  };
  languageUnitRatioStatuses: LanguageUnitRatioStatuses[];
}

export class CreativeSizeData {
  public static deserialize(creativeSizeStr: string): ICreativeSizeData {
    if (creativeSizeStr == null) {
      return null;
    }
    const creativeSize = JSON.parse(creativeSizeStr);

    return {
      languageUnitRatioStatuses: creativeSize.languageUnitRatioStatuses?.map((languageUnitRatioStatuses) =>
        LanguageUnitRatioStatuses.fromApi(languageUnitRatioStatuses),
      ),
      impressionData: creativeSize.impressionData,
    };
  }

  public static serialize(creativeSize: ICreativeSizeData): string {
    if (creativeSize == null) {
      return null;
    }

    return JSON.stringify({
      languageUnitRatioStatuses: creativeSize.languageUnitRatioStatuses?.map((languageUnitRatioStatuses) =>
        languageUnitRatioStatuses.toApi(),
      ),
      impressionData: creativeSize.impressionData,
    });
  }
}
